import React, { useEffect, useState } from "react";
import axios from "axios";
import RecommendedCard from "../components/RecommendedCard";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

function Recommended() {
  const [recommendations, setRecommendations] = useState([]);
  const [skip, setSkip] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchRecommendations = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${API_BASE}/submissions?type=recommendation&limit=25&skip=${skip}`
      );
      setRecommendations((prev) => [...prev, ...res.data]);
    } catch (err) {
      alert("Failed to load recommendations");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRecommendations();
  }, [skip]);

  return (
    <div style={{ maxWidth: "1000px", margin: "30px auto", padding: "20px" }}>
      <h2>All Fan Recommendations</h2>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "12px",
        }}
      >
        {recommendations.map((sub) => (
          <RecommendedCard key={sub._id} submission={sub} />
        ))}
      </div>

      {recommendations.length > 0 && (
        <div style={{ textAlign: "center", marginTop: "30px" }}>
          {recommendations.length % 25 === 0 ? (
            <button
              onClick={() => setSkip(skip + 25)}
              disabled={loading}
              style={{
                padding: "10px 20px",
                borderRadius: "20px",
                backgroundColor: "#4dabf7",
                color: "#fff",
                fontSize: "1rem",
                border: "none",
                cursor: "pointer",
              }}
            >
              {loading ? "Loading..." : "See next set >>"}
            </button>
          ) : (
            <p style={{ fontSize: "1rem", color: "#555" }}>
              🎉 You've reached the end!
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default Recommended;
